import { atom } from 'recoil';
import { STORE_KEYS } from '../keys';


export const loanFilter = atom<string>({
  key: STORE_KEYS.LOAN_FILTER,
  default: 'Application'
});
